import "./App.css";
import Invite from "./components/Invite";

function App() {
  return (
    <div className="App">
      <Invite />
    </div>
  );
}

export default App;
